import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { Plus, Edit, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { adminApi } from '@/lib/api';

export default function AdminCoursesPage() {
  const { t } = useTranslation();

  const { data: courses, isLoading } = useQuery({
    queryKey: ['admin-courses'],
    queryFn: () => adminApi.getCourses(),
  });

  if (isLoading) return <div className="p-8 text-center">Loading...</div>;

  return (
    <div>
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-3xl font-bold">Courses</h1>
        <Button asChild>
          <Link to="/admin/courses/new"><Plus className="h-4 w-4 me-2" />Add Course</Link>
        </Button>
      </div>
      <Card>
        <CardContent className="p-0">
          <table className="w-full">
            <thead className="bg-muted/50">
              <tr>
                <th className="text-left p-4">Title</th>
                <th className="text-left p-4">Price</th>
                <th className="text-left p-4">Status</th>
                <th className="text-left p-4">Enrollments</th>
                <th className="text-right p-4">Actions</th>
              </tr>
            </thead>
            <tbody>
              {courses && courses.length > 0 ? courses.map((course: any) => (
                <tr key={course.id} className="border-t">
                  <td className="p-4">
                    <p className="font-medium">{course.titleEn}</p>
                    <p className="text-sm text-muted-foreground">{course.titleAr}</p>
                  </td>
                  <td className="p-4">{course.price?.toLocaleString()} {course.currency}</td>
                  <td className="p-4">
                    <span className={`px-2 py-1 rounded text-xs ${course.isPublished ? 'bg-green-100 text-green-700' : 'bg-yellow-100 text-yellow-700'}`}>
                      {course.isPublished ? 'Published' : 'Draft'}
                    </span>
                  </td>
                  <td className="p-4">{course.enrollmentCount || 0}</td>
                  <td className="p-4 text-right">
                    <Button variant="ghost" size="sm" asChild>
                      <Link to={`/admin/courses/${course.id}`}><Edit className="h-4 w-4" /></Link>
                    </Button>
                  </td>
                </tr>
              )) : (
                <tr>
                  <td colSpan={5} className="p-8 text-center text-muted-foreground">No courses yet</td>
                </tr>
              )}
            </tbody>
          </table>
        </CardContent>
      </Card>
    </div>
  );
}
